import * as Actions from "./index";
import {ac} from '../index'
import _ from "lodash";
import {ETH_GROUP} from "../components/PatientDynamicItems/NHSDetails";
import {RES_OBJECT_STORE} from "./objectStore";
import {QB_PASSWORD} from "../components/FixedItems/Preferences/Constants";

export const baseURL = '/Patients';
export const basePaymentsServiceURL = '/api/v1/payments';

export const RES_PATIENT_REGISTRATION = {
    CREATE: {action: Actions.PATIENT_REGISTER, url: `${baseURL}/register/create`},
    SEND: {action: Actions.PATIENT_SUBMIT, url: `${baseURL}/register/send`},
    CONFIRM: {action: Actions.PATIENT_CONFIRM, url: `${baseURL}/register/confirm`},
};

export const RES_FIND_PATIENTS = {
    CLEAR: {action: Actions.CLEAR_PATIENT_SEARCH}
};

export const RES_PATIENT_DETAILS = {
    ADD: {request: Actions.REQUEST_PATIENT_ADD, receive: Actions.RECEIVE_PATIENT_ADD, url: `${baseURL}/addPatient`},
    ERROR: {action: Actions.PATIENT_ADD_ERROR},
    GET: {
        request: Actions.REQUEST_PATIENT_DETAILS,
        receive: Actions.RECEIVE_PATIENT_DETAILS,
        url: `${baseURL}/patientDetails`
    },
    GET_PORTAL_DATA: {
        request: Actions.REQUEST_PATIENT_PORTAL_DATA,
        receive: Actions.RECEIVE_PATIENT_PORTAL_DATA,
        url: `/Tablet/PatientPortalData`
    },
    SAVE: {action: Actions.SAVE_PATIENT_DETAILS, url: `${baseURL}/patientDetails`},
    SAVE_TABLET: {
        action: Actions.SAVE_PATIENT_TABLET_DETAILS,
        url: `/Tablet/patientDetails`
    },
    SAVE_PORTAL: {action: Actions.SAVE_PATIENT_PORTAL_DETAILS, url: `${baseURL}/patientDetails`},
    CLEAR: {action: Actions.CLEAR_PATIENT_DETAILS},
    SAVE_CLEAR: {action: Actions.SAVE_CLEAR_PATIENT_DETAILS},
    ADD_ONLINE: {
        request: Actions.REQUEST_PATIENT_ADD_ONLINE,
        receive: Actions.PATIENT_REGISTER,
        url: `${baseURL}/register/register`
    },
    WRITE_OFF: {action: Actions.PATIENT_WRITE_OFF, url: `${baseURL}/writeOff`},
    REACTIVATE: {
        request: Actions.REQUEST_PATIENT_REACTIVATE,
        receive: Actions.RECEIVE_PATIENT_REACTIVATE,
        url: `${baseURL}/reactivate`
    },
    GET_NOK: {
        request: Actions.REQUEST_PATIENT_NOK,
        receive: Actions.RECEIVE_PATIENT_NOK,
        url: `${baseURL}/patientNOKDetails`
    },
    SAVE_NOK: {action: Actions.SAVE_PATIENT_NOK_DETAILS, url: `${baseURL}/patientNOKDetails`},
    CLEAR_NOK: {action: Actions.CLEAR_PATIENT_NOK_DETAILS},
    SAVE_CLEAR_NOK: {action: Actions.SAVE_CLEAR_PATIENT_NOK_DETAILS},
    MED_COND: {action: Actions.SAVE_PATIENT_MED_COND, url: `${baseURL}/patientMedCond`},
    POPUPS: {
        request: Actions.REQUEST_PAT_ACTIVE_POPUPS,
        receive: Actions.RECEIVE_PAT_ACTIVE_POPUPS,
        url: `${baseURL}/patientsActivePopUps`
    },
};

export const RES_PATIENT_DETAILS_NHS = {
    GET: {
        request: Actions.REQUEST_PATIENT_NHS_DETAILS,
        receive: Actions.RECEIVE_PATIENT_NHS_DETAILS,
        url: `${baseURL}/patientNHSDetails`
    },
}

export const RES_PATIENT_APPOINTMENT = {
    ADD: {
        request: Actions.REQUEST_PATIENT_PASS,
        receive: Actions.RECEIVE_PATIENT_PASS,
        url: `${baseURL}/patientAppointment`
    },
};

export const RES_PATIENT_PAYMENTS = {
    SAVE: {
        request: Actions.REQUEST_PATIENT_PAYMENTS_SAVE,
        receive: Actions.RECEIVE_PATIENT_PAYMENTS_SAVE,
        url: `${basePaymentsServiceURL}/createPatientPayments`
    },
    CLEAR: {action: Actions.CLEAR_PATIENT_PAYMENTS_SAVE},
};

export const RES_PATIENT_PASS = {
    GET: {request: Actions.REQUEST_PATIENT_PASS, receive: Actions.RECEIVE_PATIENT_PASS, url: `${baseURL}/patientPASS`},
};

export const RES_PATIENT_MHFS = {
    GET: {
        request: Actions.REQUEST_PATIENT_MHFS,
        receive: Actions.RECEIVE_PATIENT_MHFS,
        url: `${baseURL}/medicalHistoryForms`
    },
    DEL: {
        action: Actions.SAVE_PATIENT_MHF,
        url: `${baseURL}/medicalHistoryForm`
    },
    GET_TABLET: {
        request: Actions.REQUEST_PATIENT_MHF,
        receive: Actions.RECEIVE_PATIENT_MHF,
        url: `Tablet/medicalHistoryFormForTablet`
    },
    SAVE: {
        action: Actions.SAVE_PATIENT_MHF,
        url: `/Tablet/medicalHistoryForm`
    },
    NO_CHANGE: {
        action: Actions.PATIENT_MHF_NO_CHANGE,
        url: `/Tablet/medicalHistoryFormNoChange`
    },
    SAVE_TABLET: {
        action: Actions.SAVE_PATIENT_MHF,
        url: `/Tablet/medicalHistoryForm`
    },
    CLEAR: {action: Actions.CLEAR_PATIENT_MHF},
};

export const RES_PATIENT_QUESTIONNAIRE = {
    QUERY: {
        request: Actions.REQUEST_QUERY_PATIENT_QUESTIONNAIRE,
        receive: Actions.RECEIVE_QUERY_PATIENT_QUESTIONNAIRE,
        url: `/Tablet/queryQuestionnaire`
    },
    GET: {
        request: Actions.REQUEST_PATIENT_QUESTIONNAIRE,
        receive: Actions.RECEIVE_PATIENT_QUESTIONNAIRE,
        url: `Tablet/questionnaire`
    },
    GET_BY_ID: {
        request: Actions.REQUEST_PATIENT_QUESTIONNAIRE_BY_ID,
        receive: Actions.RECEIVE_PATIENT_QUESTIONNAIRE_BY_ID,
        url: `/Tablet/questionnaireById`
    },
    SAVE: {
        action: Actions.SAVE_PATIENT_QUESTIONNAIRE,
        url: `Tablet/questionnaire`
    },
    CLEAR: {
        action: Actions.CLEAR_PATIENT_QUESTIONNAIRE,
        url: `${baseURL}/questionnaire`
    },
    COMPLETE_UNCHANGED: {
        request: Actions.REQUEST_COMPLETE_UNCHANGED,
        receive: Actions.RECEIVE_COMPLETE_UNCHANGED,
        url: `${baseURL}/completeQuestionnaireUnchanged`
    },
    PRECOMPLETIONS: {
        request: Actions.REQUEST_PRECOMPLETED_QUESTIONNAIRES,
        receive: Actions.RECEIVE_PRECOMPLETED_QUESTIONNAIRES,
        url: `${baseURL}/completedQuestionnaires`
    },
    COMPLETIONS: {
        request: Actions.REQUEST_COMPLETED_QUESTIONNAIRES,
        receive: Actions.RECEIVE_COMPLETED_QUESTIONNAIRES,
        url: `${baseURL}/completedQuestionnaires`
    },
};

export const RES_PATIENT_MCONS = {
    GET: {
        request: Actions.REQUEST_PATIENT_MCONS,
        receive: Actions.RECEIVE_PATIENT_MCONS,
        url: `${baseURL}/medicalConditions`
    },
    DEL: {action: Actions.DEL_PATIENT_MED_COND, url: `${baseURL}/patientMedCond`},
};

export const RES_PATIENT_DETAILS_SHORT = {
    GET: {
        request: Actions.REQUEST_PATIENT_DETAILS_SHORT,
        receive: Actions.RECEIVE_PATIENT_DETAILS_SHORT,
        url: `${baseURL}/patientDetailsShort`
    },
    REF: {
        request: Actions.REQUEST_PATIENT_DETAILS_SHORT,
        receive: Actions.RECEIVE_PATIENT_DETAILS_SHORT,
        url: `${baseURL}/patientRefDetails`
    },
};

export const RES_PATIENT_APPOINTMENT_SUMMARY = {
    GET: {
        request: Actions.REQUEST_PATIENT_APPOINTMENT_SUMMARY,
        receive: Actions.RECEIVE_PATIENT_APPOINTMENT_SUMMARY,
        url: `${baseURL}/appointmentSummary`
    },
    CLEAR: {action: Actions.CLEAR_PATIENT_APPOINTMENT_SUMMARY}
};

export const RES_PATIENT_APPOINTMENT_HISTORY = {
    GET: {
        request: Actions.REQUEST_PATIENT_APPOINTMENT_SUMMARY,
        receive: Actions.RECEIVE_PATIENT_APPOINTMENT_SUMMARY,
        url: `${baseURL}/appointmentSummary`
    },
    PDF: {
        request: Actions.REQUEST_PATIENT_APPOINTMENT_HISTORY_PDF,
        receive: Actions.RECEIVE_PATIENT_APPOINTMENT_HISTORY_PDF,
        url: `/Patient/PDFs/appointmentHistory.pdf`
    },
    CLEAR: {action: Actions.CLEAR_PATIENT_APPOINTMENT_SUMMARY}
};

export const RES_PATIENT_TREATMENT_HISTORY = {
    GET: {
        request: Actions.REQUEST_PATIENT_TREATMENT_HISTORY,
        receive: Actions.RECEIVE_PATIENT_TREATMENT_HISTORY,
        url: `${baseURL}/treatmentHistory`
    },
    SAVE: {action: Actions.SAVE_PATIENT_TREATMENT_HISTORY, url: `${baseURL}/treatmentHistory`},
    CLEAR: {action: Actions.CLEAR_PATIENT_TREATMENT_HISTORY}
};

export const RES_PATIENT_ACCOUNT_HISTORY = {
    GET_OVERVIEW: {
        request: Actions.REQUEST_PATIENT_ACCOUNT_HISTORY_OVERVIEW,
        receive: Actions.RECEIVE_PATIENT_ACCOUNT_HISTORY_OVERVIEW,
        url: `${baseURL}/accountHistoryOverview`
    },
    GET: {
        request: Actions.REQUEST_PATIENT_ACCOUNT_HISTORY,
        receive: Actions.RECEIVE_PATIENT_ACCOUNT_HISTORY,
        url: `${baseURL}/accountHistory`
    },
    PDF: {
        request: Actions.REQUEST_PATIENT_ACCOUNT_HISTORY_PDF,
        receive: Actions.RECEIVE_PATIENT_ACCOUNT_HISTORY_PDF,
        url: `/Patient/PDFs/patientAccount`,
    },
    CLEAR: {action: Actions.CLEAR_PATIENT_ACCOUNT_HISTORY_PDF}
};

export const RES_PATIENT_PERIO_HISTORY = {
    GET: {
        request: Actions.REQUEST_PATIENT_PERIO_HISTORY,
        receive: Actions.RECEIVE_PATIENT_PERIO_HISTORY,
        url: `${baseURL}/perioHistory`
    },
    SAVE: {action: Actions.SAVE_PATIENT_PERIO_CHART, url: `${baseURL}/perioChart`},
    CLEAR: {action: Actions.CLEAR_PATIENT_PERIO_HISTORY},
    DELETE: {action: Actions.DELETE_PATIENT_PERIO_CHART, url: `${baseURL}/perioChart`}
};

export const RES_ACCOUNT_ITEM = {
    GET_PAYMENT: {
        request: Actions.REQUEST_ACCOUNT_PAYMENT,
        receive: Actions.RECEIVE_ACCOUNT_PAYMENT,
        url: `${baseURL}/payment`
    },
    GET_RECEIPT: {
        request: Actions.REQUEST_ACCOUNT_RECEIPT,
        receive: Actions.RECEIVE_ACCOUNT_RECEIPT,
        url: `${baseURL}/receipt`
    },
    CHANGE_PAY_TYPE: {
        request: Actions.REQUEST_CHANGE_PAY_TYPE,
        receive: Actions.RECEIVE_CHANGE_PAY_TYPE,
        url: `${baseURL}/changePaymentType`
    },
    PDF: {
        request: Actions.REQUEST_ACCOUNT_ITEM_PDF,
        receive: Actions.RECEIVE_ACCOUNT_ITEM_PDF,
        url: `${baseURL}/patientAccount`
    },
    CLEAR: {action: Actions.CLEAR_PATIENT_ACCOUNT_HISTORY_PDF}
};

export const RES_PATIENT_APPOINTMENT_TREATMENT_HISTORY = {
    GET: {
        request: Actions.REQUEST_PATIENT_APPOINTMENT_TREATMENT_HISTORY,
        receive: Actions.RECEIVE_PATIENT_APPOINTMENT_TREATMENT_HISTORY,
        url: `${baseURL}/treatmentHistory`
    }
};

export const RES_PAYMENT_PLAN_HISTORY = {
    GET: {
        request: Actions.REQUEST_PAYMENT_PLAN_HISTORY,
        receive: Actions.RECEIVE_PAYMENT_PLAN_HISTORY,
        url: `${baseURL}/paymentPlanHistory`
    },
    CLEAR: {action: Actions.CLEAR_PP_HISTORY},
};

export const RES_PATIENT_REMINDERS = {
    GET: {
        request: Actions.REQUEST_PATIENT_REMINDERS,
        receive: Actions.RECEIVE_PATIENT_REMINDERS,
        url: `${baseURL}/reminders`
    },
};

export const RES_PATIENT_RECALLS = {
    GET: {
        request: Actions.REQUEST_PATIENT_RECALLS,
        receive: Actions.RECEIVE_PATIENT_RECALLS,
        url: `${baseURL}/recalls`
    },
};

export const RES_PATIENT_NOTES = {
    GET: {
        request: Actions.REQUEST_PATIENT_NOTES,
        receive: Actions.RECEIVE_PATIENT_NOTES,
        url: `${baseURL}/patientNotes`
    },
    PDF_ALL: {
        request: Actions.REQUEST_PATIENT_NOTE_HISTORY_PDF,
        receive: Actions.RECEIVE_PATIENT_NOTE_HISTORY_PDF,
        url: `/Patient/PDFs/patientNoteHistory`
    },
    SAVE: {action: Actions.SAVE_PATIENT_NOTES, url: `${baseURL}/patientNotes`},
    CLOSE: {action: Actions.CLOSE_PATIENT_NOTES, url: `${baseURL}/patientNotesClose`},
    CLEAR: {action: Actions.CLEAR_PATIENT_NOTES},
    DELETE: {action: Actions.DELETE_PATIENT_NOTE, url: `${baseURL}/patientNote`},
};

export const RES_PATIENT_APPOINTMENT_NOTES = {
    GET: {
        request: Actions.REQUEST_PATIENT_APPOINTMENT_NOTES,
        receive: Actions.RECEIVE_PATIENT_APPOINTMENT_NOTES,
        url: `${baseURL}/patientNotes`
    },
    SAVE: {action: Actions.SAVE_PATIENT_APPOINTMENT_NOTES, url: `${baseURL}/patientNotes`},
    CLOSE: {action: Actions.CLOSE_PATIENT_APPOINTMENT_NOTES, url: `${baseURL}/patientNotesClose`},
    CLEAR: {action: Actions.CLEAR_PATIENT_APPOINTMENT_NOTES},
    DELETE: {action: Actions.DELETE_PATIENT_APPOINTMENT_NOTE, url: `${baseURL}/patientNote`},
};

export const RES_PATIENT_XRAY_RECORDS = {
    GET: {
        request: Actions.REQUEST_PATIENT_XRAY_RECORDS,
        receive: Actions.RECEIVE_PATIENT_XRAY_RECORDS,
        url: `${baseURL}/xrayRecords`
    },
    GET_REF: {
        request: Actions.REQUEST_PATIENT_XRAY_REF,
        receive: Actions.RECEIVE_PATIENT_XRAY_REF,
        url: `${baseURL}/xrayRef`
    },
    SAVE: {action: Actions.SAVE_PATIENT_XRAY_RECORDS, url: `${baseURL}/xrayRecords`},
    CLEAR: {action: Actions.CLEAR_PATIENT_XRAY_RECORDS},
    DELETE: {action: Actions.DELETE_PATIENT_XRAY_RECORD, url: `${baseURL}/xrayRecord`},
};

export const RES_PATIENT_SEDATION_RECORDS = {
    GET: {
        request: Actions.REQUEST_PATIENT_SEDATION_RECORDS,
        receive: Actions.RECEIVE_PATIENT_SEDATION_RECORDS,
        url: `/Sedation/sedationRecords`
    },
    SAVE: {action: Actions.SAVE_PATIENT_SEDATION_RECORDS, url: `/Sedation/sedationRecords`},
    CLEAR: {action: Actions.CLEAR_PATIENT_SEDATION_RECORDS},
    DELETE: {action: Actions.DELETE_PATIENT_SEDATION_RECORD, url: `/Sedation/sedationRecord`},
};

export const RES_PATIENT_DOCUMENTS = {
    GET: {
        request: Actions.REQUEST_PATIENT_DOCUMENTS,
        receive: Actions.RECEIVE_PATIENT_DOCUMENTS,
        url: `${baseURL}/patientDocuments`
    },
    GET_BY_TYPE: {
        request: Actions.REQUEST_PATIENT_DOCUMENTS_BY_TYPE,
        receive: Actions.RECEIVE_PATIENT_DOCUMENTS_BY_TYPE,
        url: `${baseURL}/patientDocumentsByType`
    },
    CREATE: {action: Actions.CREATE_PATIENT_DOCUMENTS, url: `${baseURL}/createDocument`},
    CREATE_PRESCRIPTION: {action: Actions.CREATE_PATIENT_DOCUMENTS, url: `${baseURL}/createPrescription`},
    SAVE: {action: Actions.SAVE_PATIENT_DOCUMENTS, url: `${baseURL}/updateDocument`},
    OPEN: {action: Actions.OPEN_PATIENT_DOCUMENTS, url: `${baseURL}/openPatientDocument`},
    DELETE: {action: Actions.DELETE_PATIENT_DOCUMENTS, url: `${baseURL}/deleteDocument`},
    TRANSFER: {action: Actions.DELETE_PATIENT_DOCUMENTS, url: `${baseURL}/transferDocument`},
    USE_AS_PHOTO: {action: Actions.USE_AS_PHOTO, url: `${baseURL}/useAsPhoto`},
    PDF: {
        request: Actions.REQUEST_PATIENT_DOCUMENT_PDF,
        receive: Actions.RECEIVE_PATIENT_DOCUMENT_PDF,
        url: `${baseURL}/openPatientDocument`
    },
};

export const RES_sendPatientDocument = {
    PREVIEW: {action: Actions.PREVIEW_PATIENT_DOCUMENT, url: `/Patients/previewPatientDocument`},
    SEND: {action: Actions.SEND_PATIENT_DOCUMENT, url: `/Patients/sendPatientDocument`},
};

export const RES_uploadImageFile = {
    UPLOAD: {
        request: Actions.REQUEST_IMAGE_DATA,
        receive: Actions.RECEIVE_IMAGE_DATA,
        url: `/api/v1/upload/image`
    },
};

export const RES_sendAccountItem = {
    PREVIEW: {action: Actions.PREVIEW_ACCOUNT_ITEM, url: `/Patients/previewAccountItem`},
    SEND: {action: Actions.SEND_ACCOUNT_ITEM, url: `/Patients/sendAccountItem`},
};

export const RES_PATIENT_BILLING_GROUP = {
    GET: {
        request: Actions.REQUEST_PATIENT_BILLING_GROUP,
        receive: Actions.RECEIVE_PATIENT_BILLING_GROUP,
        url: `${baseURL}/billingGroup`
    },
    ADD: {action: Actions.ADD_PATIENT_BILLING_GROUP, url: `${baseURL}/addBillingGroup`},
    UPDATE: {action: Actions.UPDATE_PATIENT_BILLING_GROUP, url: `${baseURL}/updateBillingGroup`},
    REMOVE: {action: Actions.REMOVE_PATIENT_BILLING_GROUP, url: `${baseURL}/updateBillingGroup`},
    DELETE: {action: Actions.DELETE_PATIENT_BILLING_GROUP, url: `${baseURL}/deleteBillingGroup`},
    UPDATE_IN_FIND: {
        action: Actions.UPDATE_PATIENT_BG_IN_FIND,
        url: `${baseURL}/updateBillingGroup`
    },
    GET_IN_FIND: {
        request: Actions.REQUEST_PATIENT_BG_IN_FIND,
        receive: Actions.RECEIVE_PATIENT_BG_IN_FIND,
        url: `${baseURL}/billingGroup`
    },
};

export const RES_PATIENT_ASSESSMENTS = {
    GET: {
        request: Actions.REQUEST_PATIENT_ASSESSMENTS,
        receive: Actions.RECEIVE_PATIENT_ASSESSMENTS,
        url: `${baseURL}/getPatAssessments`
    },
    SAVE: {action: Actions.SAVE_PAT_ASSESSMENT, url: `${baseURL}/patientAssessment`},
    CLEAR: {action: Actions.CLEAR_PAT_ASSESSMENT}
};

export const RES_PATIENT_ASSESSMENTS_APPOINTMENT = {
    GET: {
        request: Actions.REQUEST_PATIENT_ASSESSMENTS_APPOINTMENT,
        receive: Actions.RECEIVE_PATIENT_ASSESSMENTS_APPOINTMENT,
        url: `${baseURL}/getPatAssessments`
    },
    SAVE: {action: Actions.SAVE_PAT_ASSESSMENT_APPOINTMENT, url: `${baseURL}/patientAssessment`},
    CLEAR: {action: Actions.CLEAR_PAT_ASSESSMENT_APPOINTMENT}
};

export const RES_ORTHO_ASSESSMENTS = {
    GET: {
        request: Actions.REQUEST_ORTHO_ASSESSMENTS,
        receive: Actions.RECEIVE_ORTHO_ASSESSMENTS,
        url: `${baseURL}/getOrthoAssessments`
    },
    SAVE: {action: Actions.SAVE_ORTHO_ASSESSMENT, url: `${baseURL}/orthoAssessment`},
    DELETE: {action: Actions.SAVE_ORTHO_ASSESSMENT, url: `${baseURL}/orthoAssessment`},
    CLEAR: {action: Actions.CLEAR_ORTHO_ASSESSMENT}
};

export const RES_ORTHO_ASSESSMENTS_APPOINTMENT = {
    GET: {
        request: Actions.REQUEST_ORTHO_ASSESSMENTS_APPOINTMENT,
        receive: Actions.RECEIVE_ORTHO_ASSESSMENTS_APPOINTMENT,
        url: `${baseURL}/getOrthoAssessments`
    },
    SAVE: {action: Actions.SAVE_ORTHO_ASSESSMENT_APPOINTMENT, url: `${baseURL}/orthoAssessment`},
    CLEAR: {action: Actions.CLEAR_ORTHO_ASSESSMENT_APPOINTMENT}
};

export const RES_PATIENT_ACCOUNT = {
    ISSUE_INVOICE: {
        request: Actions.REQUEST_PATIENT_ISSUE_INVOICE,
        receive: Actions.RECEIVE_PATIENT_ISSUE_INVOICE,
        url: `${baseURL}/issueInvoice`
    },
    ISSUE_INVOICE2: {
        request: Actions.REQUEST_PATIENT_ISSUE_INVOICE,
        receive: Actions.RECEIVE_PATIENT_ISSUE_INVOICE,
        url: `${baseURL}/issueInvoice2`
    },
    ISSUE_INVOICE3: {
        request: Actions.REQUEST_PATIENT_ISSUE_INVOICE,
        receive: Actions.RECEIVE_PATIENT_ISSUE_INVOICE,
        url: `${baseURL}/issueInvoice3`
    },
    ISSUE_RECEIPT: {
        request: Actions.REQUEST_PATIENT_ISSUE_RECEIPT,
        receive: Actions.RECEIVE_PATIENT_ISSUE_RECEIPT,
        url: `${baseURL}/issueReceipt`
    },
    ISSUE_RECEIPT2: {
        request: Actions.REQUEST_PATIENT_ISSUE_RECEIPT,
        receive: Actions.RECEIVE_PATIENT_ISSUE_RECEIPT,
        url: `${baseURL}/issueReceipt2`
    },
    ISSUE_RECEIPT3: {
        request: Actions.REQUEST_PATIENT_ISSUE_RECEIPT,
        receive: Actions.RECEIVE_PATIENT_ISSUE_RECEIPT,
        url: `${baseURL}/issueReceipt3`
    },
    MAKE_PAYMENT: {
        request: Actions.REQUEST_PATIENT_MAKE_PAYMENT,
        receive: Actions.RECEIVE_PATIENT_MAKE_PAYMENT,
        url: `${baseURL}/makePayment`
    },
    MAKE_REFUND: {
        request: Actions.REQUEST_PATIENT_MAKE_REFUND,
        receive: Actions.RECEIVE_PATIENT_MAKE_REFUND,
        url: `${baseURL}/makeRefund`
    },
    ISSUE_CREDIT: {
        request: Actions.REQUEST_PATIENT_ISSUE_CREDIT,
        receive: Actions.RECEIVE_PATIENT_ISSUE_CREDIT,
        url: `${baseURL}/makeRefund`
    },
    RECALC: {
        request: Actions.REQUEST_PATIENT_ACCOUNT_RECALC,
        receive: Actions.RECEIVE_PATIENT_ACCOUNT_RECALC,
        url: `${baseURL}/recalcAccount`
    },
};

export const RES_PATIENT_ACCESS = {
    ADD: {action: Actions.PATIENT_ACCESS_ADD, url: `${baseURL}/accessHistory`},
    GET: {
        request: Actions.REQUEST_PATIENT_ACCESS,
        receive: Actions.RECEIVE_PATIENT_ACCESS,
        url: `${baseURL}/accessHistory`
    },
    CLEAR: {action: Actions.CLEAR_PATIENT_ACCESS}
};

export const RES_PLAN_PROVIDERS = {
    GET: {
        request: Actions.REQUEST_PLAN_PROVIDERS,
        receive: Actions.RECEIVE_PLAN_PROVIDERS,
        url: `${baseURL}/allPlanProviders`
    },
};

export const RES_PATIENT_SMS = {
    SEND: {action: Actions.SEND_SMS, url: `${baseURL}/sendSMS`},
    CREDIT_LIMIT: {
        request: Actions.REQUEST_SMS_CREDIT_LIMIT,
        receive: Actions.RECEIVE_SMS_CREDIT_LIMIT,
        url: `${baseURL}/creditLimit`
    },
};

export const RES_PATIENT_EMAIL = {
    SEND: {action: Actions.SEND_EMAIL, url: `${baseURL}/sendEmail`},
};

export const RES_RESEND_PATIENT_PORTAL = {
    SEND: {action: Actions.RESEND_PORTAL_REFERENCE, url: `${baseURL}/resendPatientRef`},
};

export const RES_PATIENT_PASSWORD = {
    RESET: {action: Actions.RESET_PORTAL_PASSWORD, url: `${baseURL}/resetPatientPassword`},
};

export const getResource = ({url, request, receive}, params) => {

    return (dispatch) => {

        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...params}})
            .then(res => {
                if (res !== undefined) {
                    dispatch({type: receive, payload: res.data, ...params});
                }
            });
        dispatch({type: request, payload: false, ...params,});
    }
};

// this is required as there is a sharing between patient and appointment request that need a requesterRef
export const getResource2 = ({url, request, receive}, requesterLoadedRef, requesterRef, params) => {

    return (dispatch) => {

        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...params}})
            .then(res => {

                dispatch({
                    type: receive,
                    payload: res.data,
                    smLoadedRef: requesterLoadedRef,
                    smRef: requesterRef, ...params
                })
            });
        dispatch({type: request, payload: false, ...params,});
    }
};

export const savePatientData = ({url, request, receive}, patient, patientNOK, _NHSRegistration) => {

    return (dispatch) => {

        let NHSRegistration = {..._NHSRegistration};

        if (patient && patient.NHSPatient) {

            NHSRegistration.ethnicGroup = _.find(ETH_GROUP, group => group.code === NHSRegistration.ethnicGroup.code).value;

            if (NHSRegistration.nhsNumber.trim() === '') {
                NHSRegistration.nhsNumber = '000000000'
            }
        } else {
            NHSRegistration = null;
        }
        const data = {patient, patientNOK, NHSRegistration};

        ac.fetchClient().post(`${url}/?mcId=${ac.getMcId()}`, data)
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const savePatientDataWithMcId = ({url, request, receive}, mcId, patient, _NHSRegistration) => {

    return (dispatch) => {

        let NHSRegistration = {..._NHSRegistration};
        NHSRegistration.ethnicGroup = _.find(ETH_GROUP, group => group.code === NHSRegistration.ethnicGroup.code).value;

        if (NHSRegistration.nhsNumber.trim() !== '') {
            patient.NHSPatient = true;
        } else {
            NHSRegistration = null;
            patient.NHSPatient = false;
        }

        const data = {patient, NHSRegistration};

        ac.fetchClient().post(`${url}/?mcId=${mcId}`, data)
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const savePatientNHSData = ({url, request, receive}, data) => {

    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, data)
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const issueReceipt = ({url, request, receive}, receipt, salesInvoice, receiptChargesToSend, removeCharges) => {

    return (dispatch) => {

        const receiptCharges = receiptChargesToSend.constructor === Array ? receiptChargesToSend : [{...receiptChargesToSend}];

        const params = {params: {receipt, salesInvoice, receiptCharges, removeCharges}};

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, params)
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const issueReceipt2 = ({url, request, receive}, receipt, treatmentPlanId, salesInvoice) => {

    return (dispatch) => {

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}&treatmentPlanId=${treatmentPlanId}&salesInvoice=${salesInvoice}`, receipt)
            .then((res) => {
                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const issueReceipt3 = ({
                                  url,
                                  request,
                                  receive
                              }, receipt, salesInvoice, receiptChargesToSend, removeCharges, ppId) => {

    return (dispatch) => {

        const receiptCharges = receiptChargesToSend.constructor === Array ? receiptChargesToSend : [{...receiptChargesToSend}];

        const params = {params: {receipt, salesInvoice, receiptCharges, removeCharges}};

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}&ppId=${ppId}`, params)
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const issueInvoice = ({url, request, receive}, invoice, invoiceChargesToSend, removeCharges) => {

    return (dispatch) => {

        const invoiceCharges = invoiceChargesToSend.constructor === Array ? invoiceChargesToSend : [{...invoiceChargesToSend}];

        const params = {params: {invoice, invoiceCharges, removeCharges}};

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, params)
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const issueInvoice2 = ({url, request, receive}, invoice, treatmentPlanId) => {

    return (dispatch) => {

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}&treatmentPlanId=${treatmentPlanId}`, invoice)
            .then((res) => {
                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const issueInvoice3 = ({url, request, receive}, invoice, invoiceChargesToSend, removeCharges, ppId) => {

    return (dispatch) => {

        const invoiceCharges = invoiceChargesToSend.constructor === Array ? invoiceChargesToSend : [{...invoiceChargesToSend}];

        const params = {params: {invoice, invoiceCharges, removeCharges}};

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}&ppId=${ppId}`, params)
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const updatePassword = (password) => {

    const object = {[QB_PASSWORD]: password};

    return (dispatch) => {
        ac.fetchClient().post(`${RES_OBJECT_STORE.SET.url}?mcId=${ac.getMcId()}`, object)
            .then(() => {
                dispatch({type: RES_OBJECT_STORE.SET.receive, payload: []})
            });
    }
}
export const makePayment = ({url, request, receive}, _payment) => {

    const payment = {..._payment};

    payment.takenBy = {id: _payment.takenBy.id};

    return (dispatch) => {

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, payment)
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const makeRefund = ({url, request, receive}, _refund, refundedToDate, accountGroupId) => {

    return (dispatch) => {

        const refund = JSON.stringify(_refund);

        const details = {refund, refundedToDate, accountGroupId};

        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...details}})
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const issueCreditNote = ({url, request, receive}, creditNote, creditedToDate) => {

    return (dispatch) => {

        const details = {creditNote, creditedToDate};

        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...details}})
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const recalculateAccount = ({url, request, receive}, details) => {

    return (dispatch) => {

        ac.fetchClient().get(`${url}/?mcId=${ac.getMcId()}`, {params: {...details}})
            .then((res) => {

                dispatch({type: receive, payload: res.data})
            });
        dispatch({type: request, payload: false});
    }
};

export const createDocument = ({url, action}, details) => {

    const jsonDetails = {...details};
    jsonDetails.templateName = JSON.stringify(details.templateName);

    return (dispatch) => {

        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...jsonDetails}})
            .then((res) => {

                dispatch({type: action, payload: res.data, filename: document.filename})
            });
    }
};

export const createPrescription = ({url, action}, details) => {

    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, details)
            .then((res) => {

                dispatch({type: action, payload: res.data, filename: document.filename})
            });
    }
};

export const imageFileUpload = ({url, request, receive}, details, imageData) => {

    return (dispatch) => {
        ac.fetchUploadClient().post(`${url}/${ac.getMcId()}/${details.createdById}/${details.patientId}`, imageData)
            .then((res) => {

                dispatch({type: request, payload: res.data})
            });
    }
};

export const addMedicalCondition = ({url, action}, patientId, condition) => {

    return (dispatch) => {

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}&patientId=${patientId}`, condition)
            .then((res) => {

                dispatch({type: action, payload: res.data, patientId})
            });
    }
};

export const delMedicalCondition = ({url, action}, conditionId) => {

    return (dispatch) => {
        ac.fetchClient().delete(`${url}/?mcId=${ac.getMcId()}&conditionId=${conditionId}`)
            .then((res) => {
                dispatch({type: action, payload: {conditionId}});
            });
    }
};

export const delPatientMHF = ({url, action}, formId) => {

    return (dispatch) => {
        ac.fetchClient().delete(`${url}/?mcId=${ac.getMcId()}&formId=${formId}`)
            .then((res) => {
                dispatch({type: action, payload: {formId}});
            });
    }
};

export const openDocument = ({url, action}, document) => {

    const UUID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    return (dispatch) => {

        ac.fetchClient()({
            url: `${url}/${ac.getMcId()}/${document.filename}/${document.type}/${UUID}`,
            method: 'GET',
            responseType: 'blob'
        })
            .then((res) => {

                dispatch({type: action, payload: res.data, filename: document.filename})
            });
    }
};

export const deleteDocument = ({url, action}, patientId, delType, id) => {

    return (dispatch) => {

        ac.fetchClient().delete(`${url}/?mcId=${ac.getMcId()}&delType=${delType}&id=${id}`)
            .then((res) => {

                dispatch({type: action, payload: res.data, patientId, delType, id})
            });
    }
};

export const transferDocument = ({url, action}, patientId, id) => {

    return (dispatch) => {

        ac.fetchClient().post(`${url}/?mcId=${ac.getMcId()}&documentId=${id}&newPatientId=${patientId}`)
            .then((res) => {

                dispatch({type: action, payload: res.data, patientId, id})
            });
    }
};

export const setPhotoImage = ({url, action}, docId, appointmentId) => {

    return (dispatch) => {

        ac.fetchClient().post(`${url}/?mcId=${ac.getMcId()}&docId=${docId}&appointmentId=${appointmentId}`)
            .then((res) => {

                dispatch({type: action, payload: res.data})
            });
    }
};

export const deletePatientNote = ({url, action}, requesterLoadedRef, requesterRef, noteId) => {

    return (dispatch) => {

        ac.fetchClient().delete(`${url}/?mcId=${ac.getMcId()}&noteId=${noteId}`)
            .then((res) => {

                dispatch({
                    type: action,
                    payload: res.data,
                    smLoadedRef: requesterLoadedRef,
                    smRef: requesterRef,
                    noteId,
                })
            });
    }
};

export const deleteXRAYRecord = ({url, action}, appointmentId, recordId) => {

    return (dispatch) => {

        ac.fetchClient().delete(`${url}/?mcId=${ac.getMcId()}&recordId=${recordId}`)
            .then((res) => {

                dispatch({type: action, payload: res.data, appointmentId, recordId})
            });
    }
};

export const deleteSedationRecord = ({url, action}, appointmentId, recordId) => {

    return (dispatch) => {

        ac.fetchClient().delete(`${url}/?mcId=${ac.getMcId()}&recordId=${recordId}`)
            .then((res) => {

                dispatch({type: action, payload: res.data, appointmentId, recordId})
            });
    }
};

export const addPatientAccess = ({url, action}, params) => {

    return (dispatch) => {

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, params)
            .then(res => {
            });
    }
};

export const saveBillingGroup = ({url, action}, billingGroup, patientId) => {

    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, billingGroup)
            .then((res) => {
                dispatch({type: action, payload: res.data, patientId});
            });
    }
};

export const saveBillingGroupFromFind = ({url, action}, billingGroup) => {

    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, billingGroup)
            .then((res) => {
                dispatch({type: action, payload: res.data});
            });
    }
};

export const getMedicalHistory = ({url, request, receive}, patientId) => {

    return (dispatch) => {
        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {patientId}})
            .then((res) => {
                dispatch({type: receive, payload: res.data, patientId});
            });
        dispatch({type: request, payload: false});
    }
};

export const saveMedicalHistory = ({url, action}, medicalHistoryForm) => {

    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, medicalHistoryForm)
            .then((res) => {
                dispatch({type: action, payload: res.data});
            });
    }
};

export const savePatientNOK = ({url, action}, patientNOKData) => {

    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, patientNOKData)
            .then((res) => {
                dispatch({type: action, payload: res.data});
            });
    }
};

export const savePatientNote = ({url, action}, requesterRef, patientNote) => {

    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, patientNote)
            .then((res) => {
                dispatch({type: action, payload: res.data, smRef: requesterRef});
            });
    }
};

export const closePatientNote = ({url, action}, requesterRef, params) => {

    return (dispatch) => {
        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...params}})
            .then((res) => {
                dispatch({type: action, payload: res.data, smRef: requesterRef});
            });
    }
};

export const getQuestionnaire = ({url, request, receive}, params) => {

    return (dispatch) => {
        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...params}})
            .then((res) => {
                dispatch({type: receive, payload: res.data, ...params});
            });
        dispatch({type: request, payload: false});
    }
};

export const saveQuestionnaire = ({url, action}, questionnaire) => {

    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, questionnaire)
            .then((res) => {
                dispatch({type: action, payload: res.data});
            });
    }
};

export const deleteBillingGroup = ({url, action}, groupId) => {

    return (dispatch) => {
        ac.fetchClient().delete(`${url}/?mcId=${ac.getMcId()}&billingGroupId=${groupId}`)
            .then((res) => {
                dispatch({type: action, payload: groupId})
            });
    }
};

export const deleteItem = ({url, action}, details) => {

    return (dispatch) => {
        ac.fetchClient().delete(`${url}/?mcId=${ac.getMcId()}`, {params: {...details}})
            .then((res) => {
                dispatch({type: action, payload: details})
            });
    }
};

export const getSMSCreditLimit = ({url, request, receive}) => {

    return (dispatch) => {
        ac.fetchClient().get(`${url}/?mcId=${ac.getMcId()}`)
            .then((res) => {
                dispatch({type: receive, payload: res.data});
            });
        dispatch({type: request, payload: false});
    }
};

export const sendSMS = ({url, action}, details) => {

    const params = {params: {...details}};

    return (dispatch) => {
        ac.fetchClient().get(`${url}/?mcId=${ac.getMcId()}`, params)
            .then((res) => {
                dispatch({type: action, payload: params})
            });
    }
};

export const sendEmail = ({url, action}, sentById, patientId, email, subject, message) => {

    return (dispatch) => {

        const params = {sentById, patientId, email, subject, message};

        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, params)
            .then((res) => {

                dispatch({type: action, payload: res.data})
            });
    }
};

export const resendPortalReference = ({url, action}, patientId) => {

    return (dispatch) => {
        ac.fetchClient().get(`${url}/?mcId=${ac.getMcId()}`, {params: {patientId}})
            .then((res) => {
                dispatch({type: action, payload: true})
            });
    }
};

export const previewPatientDocument = ({url, action}, document, previewToken) => {

    return (dispatch) => {

        const params = {
            document: JSON.stringify(document),
            previewToken,
        };

        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...params}})
            .then(res => {
                // nothing is dispatched as a popup will occur via WS
            });
    }
};

export const previewAccountItem = ({url, action}, details, previewToken) => {

    return (dispatch) => {

        const params = {
            details: JSON.stringify(details),
            previewToken,
        };

        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...params}})
            .then(res => {
                // nothing is dispatched as a popup will occur via WS
            });
    }
};

export const sendPatientDocument = ({url, action}, document, message, idToken, images) => {

    return (dispatch) => {

        const params = {
            document: JSON.stringify(document),
            message,
            idToken,
            images: JSON.stringify(images)
        };

        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...params}})
            .then(res => {
                // nothing is dispatched as a popup will occur via WS
            });
    }
};

export const sendAccountItem = ({url, action}, details, message, idToken) => {

    return (dispatch) => {

        const params = {
            details: JSON.stringify(details),
            message,
            idToken
        };

        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {...params}})
            .then(res => {
                // nothing is dispatched as a popup will occur via WS
            });
    }
};

export const patientRegister = ({url, action}, mcId, inputForm) => {

    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${mcId}`, inputForm)
            .then(res => {

                dispatch({type: action, payload: res.data})
            });
    }
};

export const resetPassword = ({url, action}, portalReference) => {

    return (dispatch) => {
        ac.fetchClient().get(`${url}?mcId=${ac.getMcId()}`, {params: {portalReference}})
            .then(res => {

                dispatch({type: action, payload: res.data})
            });
    }
};

export const writeOffAccount = ({url, action}, _params) => {

    const params = {
        jsonPatientId: _params.patientId,
        jsonWrittenOffById: _params.loginIdentity.id,
        jsonGeneralNote: {..._params.note, createdBy: {id: _params.loginIdentity.id}},
    }
    return (dispatch) => {
        ac.fetchClient().post(`${url}?mcId=${ac.getMcId()}`, params)
            .then(res => {

                dispatch({type: action, payload: res.data})
            });
    }
};

export const getPDFDocument = ({url, request, receive}, params) => {

    return (dispatch) => {
        ac.fetchClient().get(`${url}/${ac.getMcId()}/${params.filename}/${params.type}/${params.key}`, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            },
        })
            .then(res => {
                dispatch({type: receive, payload: res.data, docId: params.docId})
            });
        dispatch({type: request, payload: {}, docId: params.docId});
    }
};
